import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {TranslationContainer} from "../TranslationsList.style";
import {TranslationRecord} from "../TranslationRecord";
import {setActiveRecord, setActiveRecordId} from "../../../../../slices/translationsSlice";

export const WelcomeSlogans = () => {
    const dispatch = useDispatch();
    const {menu} = useSelector(state => state.cms.fetchActiveMenu);

    return (
        <TranslationContainer $hasParent={false}>
            <TranslationRecord record={menu}
                               childTranslatableKey={'message'}
                               setActive={() => {
                                   dispatch(setActiveRecordId('c' + menu.id));
                                   dispatch(setActiveRecord(menu));
                               }}
            />
        </TranslationContainer>
    );
}